import { useMutation, useQueryClient } from '@tanstack/react-query'
import { httpCreateRoadmapActivity } from '@/features/roadmaps/http/roadmap.http'
import type {
	HttpCreateRoadmapActivityPayload,
	RoadmapActivity
} from '@/features/roadmaps/types'
import { MUTATION_KEYS, QUERY_KEYS } from '@/query-client'

interface UseCreateRoadmapActivityProps {
	onSuccess?: (data: RoadmapActivity) => void
	onError?: (error: unknown) => void
}

export const useCreateRoadmapActivity = (
	options?: UseCreateRoadmapActivityProps
) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationKey: [MUTATION_KEYS.CREATE_ROADMAP_ACTIVITY],
		mutationFn: (payload: HttpCreateRoadmapActivityPayload) =>
			httpCreateRoadmapActivity(payload),
		onError: (error) => options?.onError?.(error),
		onSuccess: (data) => {
			// Every window is its own cache entry and the new bar may land in
			// any of them, so the whole list key is invalidated rather than one
			// range.
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.GET_ROADMAP_ACTIVITIES]
			})
			options?.onSuccess?.(data)
		}
	})
}
